import { defineRule, configure } from 'vee-validate'
import * as rules from '@vee-validate/rules'
import { localize } from '@vee-validate/i18n'
import ja from '@vee-validate/i18n/dist/locale/ja.json'

// vee-validate の標準ルールを設定
// ("all" は全ルールをまとめたオブジェクト、"toTypedSchema" はzodスキーマ変換用のユーティリティ関数のため、
//  ルール関数のみを対象にする)
for (let rule in rules) {
  if (typeof rules[rule] === 'function') {
    defineRule(rule, rules[rule])
  }
}

// Install vee-validate locales.
configure({
  generateMessage: localize({
    ja,
  }),
})

// vee-validate のロケールを設定（デフォルトは英語）
localize('ja')